import React from 'react'
import Feed from '../home-components/Feed'
import FeedsHeader from '../home-components/FeedsHeader'

const Feeds = () => {
    return (
        <div className="sondaria-feeds">
  
            <FeedsHeader/>
            <div className="feeds-scroll-view">
                <Feed/>
                <Feed/>
                <Feed/>
                <Feed/>
                <Feed/>
                <Feed/>
                <Feed/>
                <Feed/>
            </div>
        </div>
    )
}

export default Feeds
